import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    content: {
        flexGrow: 1,
        padding: '20px 20px 5px',
        backgroundColor: '#0c0e30',
        [theme.breakpoints.down('901')]: {
            paddingBottom: '80px'
        }
    },

    Typography: {
        color: '#AEB4BE',
        textAlign: 'justify',
        marginTop: '10px'
    },

    gridContainer: {
        [theme.breakpoints.up('960')]: {
            width: '90%',
            margin: 'auto'
        }
    },

    copyRight: {
        textAlign: 'center',
        fontSize: '1.1rem',
        color: '#e6e8eb',
    }
}));